import React, { useEffect } from 'react'
import "./TeamInfoPanel.css"
// import { teamsData } from '../../assets/teams/data';
import { useDispatch, useSelector } from 'react-redux';
import { hideTeamInfoPanel, selectMember } from '../../features/serviceSlice';

const TeamInfoPanel = () => {
  const dispatch = useDispatch();
  const {
    selectedTeamMember,
    teamsData
  } = useSelector(state => state.service);

  const data = teamsData.find((x, i) => i === selectedTeamMember);


  useEffect(() => {
  }, [selectedTeamMember])

  if (!data) return null;

  return (
    <>
      <div className="profile-wrapper">
        <button
          type="button"
          className="team-profile-close-btn"
          onClick={(event) => {
            event.stopPropagation();
            dispatch(hideTeamInfoPanel());
            dispatch(selectMember(null));
          }}
        >
          &#10005; Close
        </button>

        <h1 className="profile-name">{data?.first_name} {data?.last_name}</h1>

        <h2 className="profile-title">
          {data?.short_title}, {data?.long_title}
        </h2>

        <p dangerouslySetInnerHTML={{ __html: data?.description }}>
        </p>

        {/* <p>
        {data?.desc}
      </p> */}
      </div>

      <h3 className="side-vertical-heading right-minus-10">
        {data?.first_name} {data?.last_name} <span className="spacer"></span> {data?.short_title}
      </h3>
    </>
  )
}

export default TeamInfoPanel
